import { useTranslation } from 'react-i18next';

// NL / EN toggle. i18next's LanguageDetector (configured in src/i18n.js)
// persists the choice to localStorage, so it sticks across pages and visits.
const LANGUAGES = [
  { code: 'nl', label: 'NL' },
  { code: 'en', label: 'EN' },
];

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage;

  return (
    <div className="lang-switcher" role="group" aria-label="Language">
      {LANGUAGES.map(({ code, label }) => (
        <button
          key={code}
          type="button"
          className={`lang-option ${current === code ? 'is-active' : ''}`}
          onClick={() => i18n.changeLanguage(code)}
          aria-pressed={current === code}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export default LanguageSwitcher;
